import React from 'react';
import WarningIcon from '../shared/WarningIcon';
import { useTranslation } from 'react-i18next';

export enum OrderWarningType {
  /** Order is scheduled outside its time window */
  LATENESS = 'lateness',
  /** Order is scheduled on a different date than requested */
  DATE_MISMATCH = 'dateMismatch',
  /** Order is assigned to a driver with mismatched tags */
  TAG_MISMATCH = 'tagMismatch',
  /** Order address matched multiple locations */
  QUESTIONABLE_ADDRESS = 'questionableAddress',
}

interface OrderWarningProps {
  types: OrderWarningType[];
}

const getMessageKeys = (types: OrderWarningType[]): string[] => {
  const keys: string[] = [];
  const hasLateness = types.includes(OrderWarningType.LATENESS);
  const hasDateMismatch = types.includes(OrderWarningType.DATE_MISMATCH);

  if (hasLateness && hasDateMismatch) {
    keys.push('visitFields.other.deliveryDateAndTimeWindowWarning');
  } else if (hasLateness) {
    keys.push('visitFields.timeWindow.defaultWarning');
  } else if (hasDateMismatch) {
    keys.push('visitFields.deliveryDate.warning');
  }

  if (types.includes(OrderWarningType.TAG_MISMATCH)) {
    keys.push('visitFields.tags.mismatchWarning');
  }

  if (types.includes(OrderWarningType.QUESTIONABLE_ADDRESS)) {
    keys.push('components:ordersForm.address.questionableTimelineLink');
  }

  return keys;
};

const OrderWarning: React.FC<OrderWarningProps> = ({ types }) => {
  const { t } = useTranslation(['common', 'components']);
  const messages = getMessageKeys(types).map((key) => t(key));

  if (messages.length === 0) {
    return null;
  }

  return (
    <span className="order-warning" data-cy="order-warning" style={{ display: 'inline-flex' }}>
      <div data-testid="order-warning">
        <WarningIcon messages={messages} />
      </div>
    </span>
  );
};

export default OrderWarning;
